const shippingAddress = {
  en: {
    translation: {
      title: "Delivery details",
      // FIELD
      city: "Select your delivery city",
      subLocality: "Sub locality",
      cap: "Post code",
      address: "Full delivery address",
      indoor: "Note",
      floor: "Floor/Apartment n.",
      phone: "Delivery phone number",
      choose_time: "Choose your delivery time",
      no_times_available: "No times available",
      date: "Delivery date",
      round: "round",
      number_person: "Number of person",
      // FIELD TAKE-AWAY
      city_take_away: "Select your takeaway city",
      title_take_away: "Takeaway details",
      phone_take_away: "Takeaway phone number",
      choose_time_take_away: "Choose your take-away time",
      date_take_away: "Takeaway date",
      // FIELD BATH_HOUSE
      address_bath_house: "Umbrella number",
      // FIELD RESERVATION
      title_reservation: "Reservation details",
      date_reservation: "Reservation date",
      choose_time_reservation: "Choose your reservation time",
      // BUTTON
      back_menu: "Back to ticket shop",
      continue: "Continue",
      cash_pay: "Pay in box office",
      // ERROR
      error_city_title: "Sorry, we're too far away from you.",
      error_city:
        "Our delivery service does not yet include this location, but we hope to be a short present in your area",
      error_cap: "Cap is not correct",
      error_address: "Define your address",
      error_address_bath_house: "Define umbrella number",

      error_telephoneDelivery: "Phone is not correct",

      error_time_title:
        "We are sorry, the selected time is no longer available",
      error_time: "Choose another delivery time",
      free: "Confirm reservation"
    }
  },
  it: {
    translation: {
      title: "Informazioni di consegna",
      // FIELD
      city: "Seleziona la tua città di consegna",
      subLocality: "Quartiere/Comune",
      cap: "Cap",
      address: "Indirizzo di consegna completo",
      indoor: "Note",
      floor: "Piano/interno",
      phone: "Telefono per la consegna",
      choose_time: "Orari disponibili per la consegna",
      no_times_available: "Nessun orario disponibile",
      date: "Data di consegna",
      round: "turno",
      number_person: "Numero di persone",
      // FIELD TAKE-AWAY
      city_take_away: "Seleziona la tua città di ritiro",
      title_take_away: "Informazioni di ritiro",
      phone_take_away: "Telefono",
      choose_time_take_away: "Orari disponibili per il ritiro",
      date_take_away: "Data per il ritiro",
      // FIELD BATH_HOUSE
      address_bath_house: "Numero ombrellone",
      // FIELD RESERVATION
      title_reservation: "Informazioni di prenotazione",
      date_reservation: "Data di prenotazione",
      choose_time_reservation: "Orari disponibili per la prenotazione",
      // BUTTON
      back_menu: "Torna alla biglietteria",
      continue: "Continua",
      cash_pay: "Paga in biglietteria",
      // ERROR
      error_city_title: "Spiacenti, siamo troppo lontani da te.",
      error_city:
        "Il nostro servizio consegne non comprende ancora questa località, ma speriamo di essere a breve presenti nella tua zona.",
      error_cap: "Il cap inserito non è corretto",
      error_address: "Inserisci il tuo indirizzo",
      error_address_bath_house: "Inserisci il numero ombrellone",

      error_telephoneDelivery: "il telefono inserito non è valido",

      error_time_title: "Spiacenti, questo orario non è più disponibile",
      error_time: "Cambia il tuo orario per la consegna",
      free: "Conferma prenotazione"
    }
  }
};

export default shippingAddress;
